import { useState, useEffect } from 'react';
import axios from 'axios';
import { base_url } from '../baseUrl';


const useCart = () => {
  const [cart, setCart] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

//   const token = localStorage.getItem('token'); 
    const storedUser = localStorage.getItem('user');
  const token = storedUser ? JSON.parse(storedUser).token : null;
  // --- Helper: Set headers
  const getHeaders = () => ({
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });

  // --- Fetch Cart
  const fetchCart = async () => {
    setLoading(true);
    setError(null);
    try {
      const { data } = await axios.get(`${base_url}api/cart`, getHeaders());
      // Ensure consistent array shape
      setCart(data?.items || data?.cart?.items || []);
    } catch (err) {
      setError(err.response?.data?.message || err.message);
    } finally {
      setLoading(false);
    }
  };

  // --- Add to Cart
  const addToCart = async (zohoItemId, quantity = 1) => {
    setLoading(true);
    setError(null);
    try {
      const { data } = await axios.post(
        `${base_url}api/cart`,
        { zohoItemId, quantity },
        getHeaders()
      );
      setCart(data?.cart?.items || []);
    } catch (err) {
      setError(err.response?.data?.message || err.message);
    } finally {
      setLoading(false);
    }
  };

  // --- Update Item Quantity
  const updateQuantity = async (zohoItemId, quantity) => {
    setLoading(true);
    setError(null);
    try {
      // Reuse addToCart logic on backend by posting again with new quantity
      const { data } = await axios.post(
        `${base_url}api/cart`,
        { zohoItemId, quantity },
        getHeaders()
      );
      setCart(data?.cart?.items || []);
    } catch (err) {
      setError(err.response?.data?.message || err.message);
    } finally {
      setLoading(false);
    }
  };

  // --- Remove from Cart
  const removeFromCart = async (zohoItemId) => {
    setLoading(true);
    setError(null);
    try {
      const { data } = await axios.delete(
        `${base_url}api/cart/${zohoItemId}`,
        getHeaders()
      );
      setCart(data?.cart?.items || []);
    } catch (err) {
      setError(err.response?.data?.message || err.message);
    } finally {
      setLoading(false);
    }
  };

  // --- Clear Cart
  const clearCart = async () => {
    setLoading(true);
    setError(null);
    try {
      const { data } = await axios.delete(`${base_url}api/cart`, getHeaders());
      setCart(data?.cart?.items || []);
    } catch (err) {
      setError(err.response?.data?.message || err.message);
    } finally {
      setLoading(false);
    }
  };

  // --- Fetch cart on mount
  useEffect(() => {
    fetchCart();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    cart,
    loading,
    error,
    fetchCart,
    addToCart,
    updateQuantity,
    removeFromCart,
    clearCart,
  };
};

export default useCart;
